import * as firebase from "firebase";

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCy5XEvjUhpoHvroV1IneuARjlx1TD9yUc",
    authDomain: "iteachlive.firebaseapp.com",
    databaseURL: "https://iteachlive.firebaseio.com",
    projectId: "iteachlive",
    storageBucket: "iteachlive.appspot.com",
    messagingSenderId: "75787562272",
    appId: "1:75787562272:web:5888384088bbf8d4"
};
firebase.initializeApp(config);

export default firebase
export const database = firebase.firestore();
export const auth = firebase.auth()






